<template>
  <div id="Admin">

    <p v-if="!ready">{{ $t('message.loading') }}</p>

    <section
      v-else
      style="padding: 10px;font-size: 13px;">
      <div class="row">
        <div class="col-12">
          <h4>Shop Daily Sale</h4>
          <h4>
            <router-link
              :to="{
                name: 'ShopDailySale',
            }">
              Back
            </router-link>
          </h4>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <GChart
            :data="chartData"
            type="LineChart"
          />
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  name: 'ShopDailySaleDetail',

  components: {
    GChart,
  },

  data () {
    return {
      ready: false,
    }
  },

  computed: {
    shopId () {
      return this.$route.query.shop_id
    },

    chartData () {
      let data = [
        ['Date', 'Sales'],
      ]

      let responseData = this.$store.getters['analytic/getState']('shopDailySale')

      for (let item of responseData) {
        data.push([item.date, item.count])
      }

      return data
    },
  },

  async created () {
    await this.$store.dispatch('analytic/getShopDailySale', this.shopId)
    this.ready = true
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/analytics/ShopDailySaleDetail.vue